export const STORE_GET_INFO_BEGIN = 'STORE_GET_INFO_BEGIN';
export const STORE_GET_INFO_SUCCESS = 'STORE_GET_INFO_SUCCESS';
export const STORE_GET_INFO_FAIL = 'STORE_GET_INFO_FAIL';
export const OTHER_STORES_INFO_BEGIN = 'OTHER_STORES_INFO_BEGIN';
export const OTHER_STORES_INFO_SUCCESS = 'OTHER_STORES_INFO_SUCCESS';
export const OTHER_STORES_INFO_FAIL = 'OTHER_STORES_INFO_FAIL';
